import React, { Component } from "react";
import { connect } from "react-redux";
import LocationOnOutlinedIcon from "@material-ui/icons/LocationOnOutlined";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { Button } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import { distance, getAllowedDistance, getPosition } from "./helpers";
import { fetchDeliveryCharges } from "../../../store/actions/store";
import * as turf from "@turf/turf";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("./gps.png" ||
    "leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("./gps.png" || "leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

class PickupExtraInfo extends Component {
  state = {
    gpsLoading: false,
  };

  getAreaName = () => {
    const {
      settings,
      language,
      branch_delivery_charges,
      areas,
      address,
      branch,
    } = this.props;
    if (settings.is_branch_based_ordering && branch.bdc && branch.bdc !== -1) {
      const bdcObj = branch_delivery_charges.find(
        (bdc) => bdc.id === branch.bdc
      );
      if (bdcObj) return language === "arabic" ? bdcObj.area_ar : bdcObj.area;
    } else if (!settings.is_branch_based_ordering && address.area) {
      const areaObj = areas.find((a) => a.id === address?.area);
      if (areaObj)
        return language === "arabic" ? areaObj.ar_name : areaObj.name;
    }
  };

  checkIfMapIsStillLoading = () => {
    if (this.state.gpsLoading) {
      this.props.modifyAddress({
        lat: "",
        lng: "",
        gpsConfirmed: false,
      });
      this.setState({ gpsLoading: false });
    }
  };

  isPointInsideAllowedArea = (selectedAreaObj, position) => {
    if (!selectedAreaObj?.shapes || selectedAreaObj?.shapes?.length === 0)
      return true;
    if (!selectedAreaObj?.shapes || !position) return false;

    const pt = turf.point([position.lng, position.lat]);

    return selectedAreaObj.shapes.some((shape) => {
      if (shape.type === "Polygon" || shape.type === "Rectangle") {
        let coords = shape.points.map((p) => [p.lng, p.lat]);
        // Ensure polygon is closed
        const first = coords[0];
        const last = coords[coords.length - 1];
        if (first[0] !== last[0] || first[1] !== last[1]) {
          coords.push(first);
        }
        const poly = turf.polygon([coords]);
        return turf.booleanPointInPolygon(pt, poly);
      }
      if (shape.type === "Circle") {
        const center = turf.point([shape.center.lng, shape.center.lat]);
        const dist = turf.distance(pt, center, { units: "meters" });
        return dist <= shape.radius; // radius in meters
      }
      if (shape.type === "Marker") {
        const marker = turf.point([shape.point.lng, shape.point.lat]);
        const dist = turf.distance(pt, marker, { units: "meters" });
        return dist <= 10; // allow 10m tolerance for marker point
      }
      return false;
    });
  };

  componentDidMount = async () => {
    if (!this.props.fetchedDeliveryCharges) {
      await this.props.fetchDeliveryCharges(this.props.country_code);
    }
    const { address, branch, branch_delivery_charges, areas, settings } =
      this.props;
    if (!address) return;
    let selectedArea;
    let selectedArea_obj;
    if (settings.is_branch_based_ordering) {
      selectedArea_obj = branch_delivery_charges.find(
        (bdc) => bdc.area_id === address?.area
      );
      if (selectedArea_obj) {
        selectedArea = {
          name: selectedArea_obj.area,
          province_name: selectedArea_obj.province_en,
        };
      }
    } else {
      selectedArea = areas.find((a) => a.id === address?.area);
    }
    const alHamraSituationTing =
      selectedArea &&
      ([
        "arraya tower",
        "arraya center",
        "nbk tower",
        "assima mall",
        "mazaya tower",
        "international hospital",
      ].some((a) => selectedArea.name.toLowerCase().includes(a)) ||
        selectedArea.province_name === "Offices") &&
      address.selectedDeliveryType === 0;

    if (alHamraSituationTing) return;
    if (!settings.ask_for_map_address) return;
    if (!address.lat || !address.lng || !address.gpsConfirmed) {
      if (navigator.geolocation) {
        this.setState({ gpsLoading: true });
        window.setTimeout(() => this.checkIfMapIsStillLoading(), 6000);
        try {
          navigator.geolocation.getCurrentPosition(
            (res) => {
              if (res.coords?.latitude && res.coords?.longitude) {
                const lat = res.coords.latitude;
                const lng = res.coords.longitude;
                const baseCoords = getPosition(
                  address,
                  branch,
                  branch_delivery_charges,
                  areas,
                  settings
                );
                if (!baseCoords) {
                  this.props.modifyAddress({
                    lat: "",
                    lng: "",
                    gpsConfirmed: false,
                  });
                } else {
                  const distanceFromBase = distance(
                    baseCoords.lat,
                    baseCoords.lng,
                    lat,
                    lng
                  );

                  if (selectedArea_obj?.shapes?.length) {
                    if (
                      !this.isPointInsideAllowedArea(selectedArea_obj, {
                        lat,
                        lng,
                      })
                    ) {
                      this.props.modifyAddress({
                        lat: "",
                        lng: "",
                        gpsConfirmed: false,
                      });
                    }
                  } else if (distanceFromBase <= getAllowedDistance())
                    this.props.modifyAddress({
                      lat,
                      lng,
                      gpsConfirmed: true,
                    });
                }
              }
              this.setState({ gpsLoading: false });
            },
            (e) => {
              this.props.modifyAddress({
                lat: "",
                lng: "",
                gpsConfirmed: false,
              });
              this.setState({ gpsLoading: false });
            },
            { enableHighAccuracy: true, timeout: 6000 }
          );
        } catch (e) {
          console.error("Couldn't capture user's coordinates ", e);
          this.setState({ gpsLoading: false });
        }
      }
    } else if (
      selectedArea_obj.shapes?.length &&
      !!address.lat &&
      !!address.lng
    ) {
      if (
        !this.isPointInsideAllowedArea(selectedArea_obj, {
          lat: address.lat,
          lng: address.lng,
        })
      )
        this.props.modifyAddress({
          lat: "",
          lng: "",
          gpsConfirmed: false,
        });
    }
  };
  render() {
    const {
      language,
      customTexts,
      themeColor,
      address,
      branch,
      branch_delivery_charges,
      areas,
      settings,
      countries,
    } = this.props;

    if (!this.props.fetchedDeliveryCharges)
      return (
        <div style={{ marginTop: 30 }}>
          <p
            className="box-title"
            style={{ textAlign: language === "arabic" ? "right" : "left" }}
          >
            {language == "arabic"
              ? "منطقة التوصيل والعنوان"
              : "Delivery Area & Location"}
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 67,
              direction: language == "english" ? "ltr" : "rtl",
              backgroundColor: "white",
              padding: "22px 17px",
              paddingBottom: 22,
            }}
            className="w-100 bordered"
          >
            <CircularProgress
              color="primary"
              style={{
                width: 20,
                height: 20,
              }}
            />
          </div>
        </div>
      );

    let selectedCountry = countries
      ? countries.find((country) => country.id == this.props.address.country)
      : null;
    const international = selectedCountry.name === "International";
    let selectedArea;

    if (settings.is_branch_based_ordering) {
      selectedArea = branch_delivery_charges.find(
        (bdc) => bdc.area_id === address?.area
      );
      if (selectedArea) {
        selectedArea = {
          name: selectedArea.area,
          province_name: selectedArea.province_en,
        };
      }
    } else {
      selectedArea = areas.find((a) => a.id === address?.area);
    }

    const useAddressLines =
      international || selectedArea?.province_name === "Kashtat";

    const alHamraSituationTing =
      selectedArea &&
      ([
        "arraya tower",
        "arraya center",
        "nbk tower",
        "assima mall",
        "mazaya tower",
        "international hospital",
      ].some((a) => selectedArea.name.toLowerCase().includes(a)) ||
        selectedArea.province_name === "Offices") &&
      address.selectedDeliveryType === 0;

    const interactionOptions = {
      zoomControl: false,
      doubleClickZoom: false,
      closePopupOnClick: false,
      dragging: false,
      zoomSnap: false,
      zoomDelta: false,
      trackResize: false,
      touchZoom: false,
      scrollWheelZoom: false,
    };
    const position = getPosition(
      address,
      branch,
      branch_delivery_charges,
      areas,
      settings
    );
    const checkGiftUnknownLocation =
      this.props.settings.enable_gifts &&
      this.props.settings.enable_gifts_staff &&
      this.props.promise.isGift &&
      this.props.settings.enable_unknown_gift_recipient_location &&
      this.props.promise.unknown_location;
    return (
      <div style={{ marginTop: 30 }}>
        <p
          className="box-title"
          style={{ textAlign: language === "arabic" ? "right" : "left" }}
        >
          {language == "arabic"
            ? "منطقة التوصيل والعنوان"
            : "Delivery Area & Location"}
        </p>
        <div
          style={{
            minHeight:
              alHamraSituationTing ||
              useAddressLines ||
              (!settings.ask_for_map_address &&
                address?.selectedDeliveryType === 0)
                ? 70
                : checkGiftUnknownLocation
                ? 67
                : 100,
            direction: language == "english" ? "ltr" : "rtl",
            backgroundColor: "white",
            padding: "22px 17px",
            paddingBottom:
              alHamraSituationTing ||
              useAddressLines ||
              (!settings.ask_for_map_address &&
                address?.selectedDeliveryType === 0)
                ? 0
                : checkGiftUnknownLocation
                ? 0
                : 22,
          }}
          className="w-100 bordered"
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "50px auto 100px",
              marginBottom: 15,
              alignItems: "center",
            }}
          >
            <span
              className={language === "arabic" ? "text-right" : "text-left"}
            >
              <LocationOnOutlinedIcon
                style={{ fontSize: 23, color: themeColor }}
              />
            </span>
            <p
              className={"mb-0 bold ".concat(
                language === "arabic" ? "text-right" : "text-left"
              )}
              style={{
                color: themeColor,
                cursor: "pointer",
              }}
              onClick={() => {
                this.props.history.push("/select/branch", {
                  goBackToAddressPage: true,
                });
              }}
            >
              {this.getAreaName() || "-"}
            </p>
            {!this.props.match.params?.address_id && (
              <div
                className={"bold ".concat(
                  language === "arabic" ? "text-left" : "text-right"
                )}
                style={{ color: "#5b5b5b", cursor: "pointer" }}
                onClick={() =>
                  this.props.history.push("/select/branch", {
                    goBackToAddressPage: true,
                  })
                }
              >
                <span style={{ marginRight: 1, fontSize: "0.9rem" }}>
                  {language === "arabic" ? "تغيير" : "Change"}
                </span>
                <NavigateNextIcon
                  style={{
                    transform: language === "arabic" && "rotate(180deg)",
                  }}
                />
              </div>
            )}
          </div>

          {!alHamraSituationTing &&
            !useAddressLines &&
            settings.ask_for_map_address &&
            !checkGiftUnknownLocation && (
              <>
                <p
                  className={"mb-1 bold ".concat(
                    language === "arabic" ? "text-right" : "text-left"
                  )}
                  style={{ color: "#5b5b5b", fontSize: "0.9rem" }}
                >
                  {language === "arabic"
                    ? "ساعدنا في الوصول اليك بسرعة ودقة"
                    : "Help us find you faster"}
                </p>
                {this.state.gpsLoading ? (
                  <div
                    style={{
                      backgroundColor: "#000000c7",
                      height: 90,
                      width: "100%",
                      display: "grid",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress
                      color="primary"
                      style={{
                        width: 20,
                        height: 20,
                      }}
                    />
                  </div>
                ) : (
                  <div
                    className="w-100"
                    style={{ height: 90, position: "relative" }}
                  >
                    <Button
                      onClick={() =>
                        this.props.history.push("/checkout/address/map")
                      }
                      style={{
                        background: "white",
                        position: "absolute",
                        [language === "arabic" ? "left" : "right"]: 15,
                        top: 10,
                        zIndex: 401,
                        top: 0,
                        bottom: 0,
                        marginTop: "auto",
                        marginBottom: "auto",
                        height: 35,
                        width: 75,
                        paddingLeft: language === "arabic" && 0,
                        boxShadow: "rgb(184 184 184) 1px 1px 1px 1px",
                      }}
                      variant="outlined"
                      color="primary"
                      endIcon={
                        <NavigateNextIcon
                          style={{
                            transform:
                              language === "arabic" && "rotate(180deg)",
                          }}
                        />
                      }
                      className="bold"
                    >
                      <span style={{ marginLeft: language === "arabic" && 6 }}>
                        {language === "arabic" ? "تعديل" : "Edit"}
                      </span>
                    </Button>
                    <MapContainer
                      center={
                        position || {
                          lat: settings.base_lat_lng?.split(",")[0],
                          lng: settings.base_lat_lng?.split(",")[1],
                        }
                      }
                      zoom={14}
                      {...interactionOptions}
                      style={{ height: 90 }}
                    >
                      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                      {!!position && <Marker position={position} />}
                    </MapContainer>
                  </div>
                )}
              </>
            )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    address: state.customers.address,
    customTexts: state.store.store.settings.custom_texts,
    themeColor: state.store.store.settings.dark || "#0099cc",
    settings: state.store.store.settings,
    branch_delivery_charges: state.store.store.branch_delivery_charges,
    branch: state.branch,
    areas: state.store.store.areas,
    promise: state.promise,
    countries: state.store.store.all_countries || state.store.store.countries,
    country_code: state.store.store.country_code,
    fetchedDeliveryCharges: state.store.fetchedDeliveryCharges,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    modifyAddress: (obj) => dispatch({ type: "MODIFY_ADDRESS", payload: obj }),
    fetchDeliveryCharges: (countryCode) =>
      dispatch(fetchDeliveryCharges(countryCode)),
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PickupExtraInfo)
);
